/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetOnboardingRequestById200ResponseBeneficialOwnersInner
 */
export interface GetOnboardingRequestById200ResponseBeneficialOwnersInner {
    /**
     * 住所
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseBeneficialOwnersInner
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseBeneficialOwnersInner
     */
    'beneficialOwnerType'?: GetOnboardingRequestById200ResponseBeneficialOwnersInnerBeneficialOwnerTypeEnum;
    /**
     * 生年月日
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseBeneficialOwnersInner
     */
    'birthday'?: string;
    /**
     * 法人との関係性
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseBeneficialOwnersInner
     */
    'corporateRelationships'?: GetOnboardingRequestById200ResponseBeneficialOwnersInnerCorporateRelationshipsEnum;
    /**
     * 居住国
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseBeneficialOwnersInner
     */
    'countryResidence'?: string;
    /**
     * 性別
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseBeneficialOwnersInner
     */
    'gender'?: GetOnboardingRequestById200ResponseBeneficialOwnersInnerGenderEnum;
    /**
     * 外国人PEPsに該当するか
     * @type {boolean}
     * @memberof GetOnboardingRequestById200ResponseBeneficialOwnersInner
     */
    'isPoliticallyExposedPersons'?: boolean;
    /**
     * 氏名・法人名
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseBeneficialOwnersInner
     */
    'name'?: string;
}

export const GetOnboardingRequestById200ResponseBeneficialOwnersInnerBeneficialOwnerTypeEnum = {
    corporation: 'CORPORATION',
    person: 'PERSON'
} as const;

export type GetOnboardingRequestById200ResponseBeneficialOwnersInnerBeneficialOwnerTypeEnum = typeof GetOnboardingRequestById200ResponseBeneficialOwnersInnerBeneficialOwnerTypeEnum[keyof typeof GetOnboardingRequestById200ResponseBeneficialOwnersInnerBeneficialOwnerTypeEnum];
export const GetOnboardingRequestById200ResponseBeneficialOwnersInnerCorporateRelationshipsEnum = {
    businessExecutor: 'BUSINESS_EXECUTOR',
    hasControllingInfluenceOverBusinessActivity: 'HAS_CONTROLLING_INFLUENCE_OVER_BUSINESS_ACTIVITY',
    hasRightOver25Per: 'HAS_RIGHT_OVER_25PER',
    hasRightOver50Per: 'HAS_RIGHT_OVER_50PER'
} as const;

export type GetOnboardingRequestById200ResponseBeneficialOwnersInnerCorporateRelationshipsEnum = typeof GetOnboardingRequestById200ResponseBeneficialOwnersInnerCorporateRelationshipsEnum[keyof typeof GetOnboardingRequestById200ResponseBeneficialOwnersInnerCorporateRelationshipsEnum];
export const GetOnboardingRequestById200ResponseBeneficialOwnersInnerGenderEnum = {
    female: 'FEMALE',
    male: 'MALE'
} as const;

export type GetOnboardingRequestById200ResponseBeneficialOwnersInnerGenderEnum = typeof GetOnboardingRequestById200ResponseBeneficialOwnersInnerGenderEnum[keyof typeof GetOnboardingRequestById200ResponseBeneficialOwnersInnerGenderEnum];


